import { AdminApi } from './';

const {REACT_APP_API_BASE_URL, REACT_APP_API_VERSION} = process.env;

export class LeadApi {
    static getAllLeads () {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/leads`, {
            ...AdminApi.GetDefualtMethod
        });
    }

    static updateLead (leadID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/leads/${leadID}`, {
            ...AdminApi.GetDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    static deleteLead (leadID) {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/leads/${leadID}`, {
            ...AdminApi.GetDefualtMethod,
            method: 'DELETE'
        });
    }    
}


// WEBPACK FOOTER //
// ./src/services/lead.js